module.exports = __webpack_public_path__ + "b6cd0d14a1fd79f530b7f74125afd7a7.jpg";